module.exports = __webpack_public_path__ + "img/ani_anionereward.d95b470.png";